import { useQuery } from '@tanstack/react-query';
import { getShareLinks } from '@/shared/api/share/getShareLinks';

type Params = Parameters<typeof getShareLinks>[0];

interface Options {
  enabled?: boolean;
}

export const useGetShareLinks = (params: Params, options?: Options) => {
  return useQuery({
    queryFn: () => getShareLinks(params),
    queryKey: getUseGetShareLinks(params),
    ...options,
    select: (data) => data.result,
  });
};

export const getUseGetShareLinks = (params: Params) => [
  'getShareLinks',
  params,
];
